<template>
	<div class="c-header">
		<div class="c-header__tabs-container">
			<div
				v-for="folder in folders"
				:key="folder.id"
				:class="['c-header__tab active']"
				@click="onClick(folder._id)"
			>
				<span v-if="folder.content">
					{{ folder.content.title }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {};
	},

	computed: {
		folders: function () {
			return this.$store.getters['folder/folders'];
		},
	},

	methods: {
		onClick: function (folderId) {
			this.$store.dispatch('dashboard/setFolder', folderId);
		},
	},
};
</script>

<style lang="scss">
.c-header {
	padding-top: var(--spacer-sm);
	background-color: var(--g2);

	&__tabs-container {
		padding: 0 var(--spacer-sm);
		overflow-x: auto;
		display: flex;

		@include scrollBars();
	}

	&__tab {
		padding: var(--margin) var(--margin-lg);
		width: 150px;
		min-width: 150px;
		display: inline-block;
		background-color: var(--g3);

		//border-top: var(--p3) solid 2px;

		span {
			font-size: var(--font-size-sm);
		}

		&.active {
			background-color: var(--g4);
		}
	}
}
</style>